import { render } from "./EditPollPage.vue?vue&type=template&id=4a05c25b&scoped=true"
import script from "./EditPollPage.vue?vue&type=script&lang=js"
export * from "./EditPollPage.vue?vue&type=script&lang=js"

import "./EditPollPage.vue?vue&type=style&index=0&id=4a05c25b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a05c25b"]])

export default __exports__